import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      orderNum: 1,
    },
  },
  {
    path: '/review',
    name: 'Review',
    meta: {
      orderNum: 2,
    },
    component: () =>{
      return import('../views/Review.vue')
    }
  },
  {
    path: '/review/animation',
    name: 'Animation',
    meta: {
      orderNum: 3,
    },
    component: function () {
      return import('../views/Animation.vue')
    }
  },
  {
    path: '/review/what-changed',
    name: 'WhatChanged',
    meta: {
      orderNum: 4,
    },
    component: function () {
      return import('../views/WhatChanged.vue')
    }
  },
  {
    path: '/review/equation',
    name: 'Equation',
    meta: {
      orderNum: 5,
    },
    component: function () {
      return import('../views/Equation.vue')
    }
  },
  {
    path: '/quiz/materials',
    name: 'Materials',
    meta: {
      orderNum: 6,
    },
    component: function () {
      return import('../views/Materials.vue')
    },
  },
  {
    path: '/quiz/apply-your-knowledge/:id',
    name: 'ApplyYourKnowledge',
    meta: {
      orderNum: 7,
    },
    props: true,
    query: {
      t: new Date().getTime(),
    },
    component: function () {
      return import('../views/ApplyYourKnowledge.vue')
    },
  },
  {
    path: '/quiz/greater-than',
    name: 'GreaterThan',
    meta: {
      orderNum: 8,
    },
    component: function () {
      return import('../views/GreaterThan.vue')
    },
  },
  {
    path: '/quiz/cost',
    name: 'Cost',
    meta: {
      orderNum: 9,
    },
    component: function () {
      return import('../views/Cost.vue')
    },
  },
  {
    path: '/question',
    name: 'Question',
    component: function () {
      return import('../views/Question.vue')
    }
  },
  {
    path: '/testdots',
    name: 'TestDots',
    component: function () {
      return import('../views/TestDots.vue')
    }
  },
  {
    path: '/quiz',
    name: 'Quiz',
    component: function () {
      return import('../views/Quiz.vue')
    },
  },
  {
    path: '/final',
    name: 'Final',
    meta: {
      orderNum: 10,
    },
    component: function () {
      return import( '../views/Final.vue' )
    }
  },
]

const router = new VueRouter({
  routes,
  mode: 'hash'
})

export default router
